import mapProps from 'recompose/mapProps';
import VideoPage from '../../../components/main/files/video';

function mapper({match}) {
	return {match};
}

export default mapProps(mapper)(VideoPage);



// WEBPACK FOOTER //
// ./src/client/pages/main/file/video.js